const timezones = [
  {label: 'Brasília - UTC -03:00', value: 'America/Sao_Paulo'},
  {label: 'Manaus - UTC -04:00', value: 'America/Manaus'},
  {label: 'Chile/Santiago - UTC -04:00', value: 'America/Santiago'},
  {label: 'Argentina - UTC -03:00', value: 'America/Buenos_Aires'}
]

export default timezones
